<div class="custom-box">
  <sia-text-box
    class="sia-input-button-box"
    [value]="value()"
    (valueChanged)="value.set($event)"
    [label]="label()"
    [disabled]="disabled()"
    [status]="status()"
    [statusMessage]="statusMessage()"
    [allowBreakLine]="false"
    [modified]="modified()"
    [id]="id() ?? ''"
    [tabindex]="tabDisabled() ? '-1' : '0'"
  ></sia-text-box>
  <sia-map-button [address]="value()"> </sia-map-button>
</div>
